<template>
  <section :class="$style.section">
    <div :class="$style.top">
      <div :class="$style.brand">
        <div :class="$style.logo">
          <img v-if="department?.logo" :src="department?.logo" alt="" />
          <div v-else :class="$style.code">{{ department?.short_code }}</div>
        </div>
        <div :class="$style.info">
          <h2 :class="$style.title">{{ department?.title }}</h2>
          <p :class="$style.address">{{ department?.address }}</p>
        </div>
      </div>
      <!-- <button
        type="button"
        :class="$style.close"
        aria-label="Закрыть"
        @click="$emit('close')"
      >
        <img src="/figma/step1-close.svg" alt="" />
      </button> -->
    </div>

    <div :class="$style.contacts">
      <a
        v-if="department?.phone_number"
        :href="`tel:${department.phone_number}`"
        :class="$style.phone"
      >
        {{ department.phone_number }}
      </a>
      <div v-if="socialLinks.length" :class="$style.socials">
        <a
          v-for="item in socialLinks"
          :key="item.key"
          :href="item.url"
          target="_blank"
          rel="noopener noreferrer"
          :class="$style.social"
          :aria-label="item.label"
        >
          <img :src="item.icon" :class="$style[`icon-${item.key}`]" alt="" />
        </a>
      </div>
    </div>

    <ProgressBar :current-step="currentStep" :total-steps="totalSteps" />
  </section>
</template>

<script>
import { mapState } from "vuex";
import ProgressBar from "../ProgressBar.vue";

export default {
  name: "HeaderSection",
  components: {
    ProgressBar,
  },
  props: {
    currentStep: {
      type: Number,
      default: 1,
    },
    totalSteps: {
      type: Number,
      default: 4,
    },
  },
  computed: {
    ...mapState({
      department: (state) => state.department.department,
    }),
    socialLinks() {
      const department = this.department || {};
      return [
        {
          key: "vk",
          label: "VK",
          icon: "/figma/step1-vk.svg",
          url: this.normalizeVkUrl(department.vk_link),
        },
        {
          key: "telegram",
          label: "Telegram",
          icon: "/figma/step1-tg.svg",
          url: this.normalizeTelegramUrl(department.telegram_link),
        },
        {
          key: "whatsapp",
          label: "WhatsApp",
          icon: "/figma/step1-wa.svg",
          url: this.normalizeWhatsAppUrl(department.whatsapp_link),
        },
        {
          key: "max",
          label: "Max",
          icon: "/figma/step1-max.svg",
          url: this.normalizeSocialUrl(department.max_link),
        },
      ].filter((item) => item.url);
    },
  },
  methods: {
    normalizeSocialUrl(value) {
      const normalized = String(value || "").trim();
      if (!normalized) {
        return "";
      }

      if (/^https?:\/\//i.test(normalized)) {
        return normalized;
      }

      return `https://${normalized.replace(/^\/+/, "")}`;
    },
    normalizeVkUrl(value) {
      const normalized = String(value || "").trim();
      if (!normalized) {
        return "";
      }

      if (/^https?:\/\//i.test(normalized)) {
        return normalized;
      }

      const username = normalized.replace(/^@/, "").replace(/^\/+/, "");
      if (!username) {
        return "";
      }

      return `https://vk.com/${username}`;
    },
    normalizeTelegramUrl(value) {
      const normalized = String(value || "").trim();
      if (!normalized) {
        return "";
      }

      if (/^https?:\/\//i.test(normalized)) {
        return normalized;
      }

      if (normalized.startsWith("@")) {
        return `https://t.me/${normalized.slice(1)}`;
      }

      return this.normalizeSocialUrl(normalized);
    },
    normalizeWhatsAppUrl(value) {
      const normalized = String(value || "").trim();
      if (!normalized) {
        return "";
      }

      if (/^https?:\/\//i.test(normalized)) {
        return normalized;
      }

      const digits = normalized.replace(/\D/g, "");
      if (digits) {
        return `https://wa.me/${digits}`;
      }

      return this.normalizeSocialUrl(normalized);
    },
  },
};
</script>

<style lang="scss" module>
.section {
  padding: 1.5rem 0 0;
}

.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  padding: 0 1.5rem;
  @include tablet {
    padding: 0 1rem;
  }
}

.brand {
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  min-width: 0;
}

.logo {
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  .code {
    border-radius: 0.5rem;
    background-color: $bg-white;
    border: 1px solid $bg-separator;
    width: 3.5rem;
    height: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 600;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.5rem;
  }
}

.info {
  min-width: 0;
  flex: 1 1 auto;
}

.title {
  font-size: 1.3125rem;
  font-weight: 600;
  margin: 0 0 0.125rem;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.address {
  margin: 0;
  font-size: 0.875rem;
  color: #2c2c2c;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close {
  border: none;
  background: transparent;
  cursor: pointer;
  line-height: 0;
  padding: 0;
  width: 1.5rem;
  height: 1.5rem;

  img {
    width: 1.5rem;
    height: 1.5rem;
    display: block;
  }
}

.contacts {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding: 0 1.5rem 1.5rem;
  flex-wrap: nowrap;
  overflow: hidden;
  @include tablet {
    padding: 0 1rem 1rem;
  }
}

.phone {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  min-height: 2.5rem;
  padding: 0.5rem 1rem;
  border-radius: 6.25rem;
  background-color: $bg-white;
  font-size: 1rem;
  font-weight: 400;
  border: 1px solid $t-primary;
  white-space: nowrap;
  flex-shrink: 0;
}

.socials {
  display: flex;
  align-items: center;
  gap: 0.375rem;
}

.social {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  background-color: $bg-white;
  color: $t-secondary;
  font-size: 0.625rem;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid $t-primary;
  flex-shrink: 0;

  img {
    object-fit: contain;
    display: block;
  }
}

.icon-vk,
.icon-whatsapp,
.icon-max {
  width: 1.25rem;
  height: 1.25rem;
}

.icon-telegram {
  width: 1.2275rem;
  height: 1rem;
}
</style>
